function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// This file was copy-pasted from:
// https://gitlab.com/catamphetamine/javascript-time-ago/-/blob/main/source/FullDateFormatter.js
var FullDateFormatter = /*#__PURE__*/function () {
  function FullDateFormatter(localeOrLocales) {
    _classCallCheck(this, FullDateFormatter);

    // See if `Intl.DateTimeFormat` is supported in the current environment.
    //
    // `Intl` is present in all modern web browsers and is only absent from some of the ancient ones.
    //
    // Babel transforms `typeof` into some "branches"
    // so istanbul will show this as "branch not covered".

    /* istanbul ignore next */
    var isIntlAvailable = (typeof Intl === "undefined" ? "undefined" : _typeof(Intl)) === 'object';
    var isIntlDateTimeFormatAvailable = isIntlAvailable && typeof Intl.DateTimeFormat === 'function';
    /* istanbul ignore else */

    if (isIntlDateTimeFormatAvailable) {
      this.formatter = new Intl.DateTimeFormat(localeOrLocales, VERBOSE_DATE_FORMAT_OPTIONS);
    } else {
      this.formatter = new FallbackDateFormatter();
    }
  }

  _createClass(FullDateFormatter, [{
    key: "format",
    value: function format(dateOrTimestamp) {
      return this.formatter.format(getDate(dateOrTimestamp));
    }
  }]);

  return FullDateFormatter;
}();

export { FullDateFormatter as default };
export var FallbackDateFormatter = /*#__PURE__*/function () {
  function FallbackDateFormatter() {
    _classCallCheck(this, FallbackDateFormatter);
  }

  _createClass(FallbackDateFormatter, [{
    key: "format",
    value: function format(date) {
      return String(date);
    }
  }]);

  return FallbackDateFormatter;
}();

function getDate(dateOrTimestamp) {
  if (typeof dateOrTimestamp === 'number') {
    return new Date(dateOrTimestamp);
  }

  return dateOrTimestamp;
} // `Intl.DateTimeFormat` options for outputting a verbose date.
// Formatted date example: "Thursday, December 20, 2012, 7:00:00 AM GMT+4"


var VERBOSE_DATE_FORMAT_OPTIONS = {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  second: '2-digit' // timeZoneName: 'short'

};
//# sourceMappingURL=FullDateFormatter.js.map